export const jobProfileConstants = {
    GETALL_REQUEST: 'JOBPROFILES_GETALL_REQUEST',
    GETALL_SUCCESS: 'JOBPROFILES_GETALL_SUCCESS',
    GETALL_FAILURE: 'JOBPROFILES_GETALL_FAILURE',

    GETALL_SUCCESS_LOADER: 'GETALL_SUCCESS_LOADER',

    CREATE_REQUEST: 'JOBPROFILES_CREATE_REQUEST',
    CREATE_SUCCESS: 'JOBPROFILES_CREATE_SUCCESS',
    CREATE_FAILURE: 'JOBPROFILES_CREATE_FAILURE',

    UPDATE_REQUEST: 'JOBPROFILES_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'JOBPROFILES_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'JOBPROFILES_UPDATE_FAILURE',

    GET_REQUEST: 'JOBPROFILES_GET_REQUEST',
    GET_SUCCESS: 'JOBPROFILES_GET_SUCCESS',
    GET_FAILURE: 'JOBPROFILES_GET_FAILURE',

    DELETE_REQUEST: 'JOBPROFILES_DELETE_REQUEST',
    DELETE_SUCCESS: 'JOBPROFILES_DELETE_SUCCESS',
    DELETE_FAILURE: 'JOBPROFILES_DELETE_FAILURE',

    GET_REQUEST: 'ASSIGNE_GET_REQUEST',
    GET_SUCCESS: 'ASSIGNE_GET_SUCCESS',
    GET_FAILURE: 'ASSIGNE_GET_FAILURE',

    GETJOB_REQUEST: 'DESIGNATION_GETJOB_REQUEST',
    GETJOB_SUCCESS: 'DESIGNATION_GETJOB_SUCCESS',
    GETJOB_FAILURE: 'DESIGNATION_GETJOB_FAILURE',


    GETJOBLIST_REQUEST: 'JOB_GET_REQUEST',
    GETJOBLIST_SUCCESS: 'JOB_GET_SUCCESS',
    GETJOBLIST_FAILURE: 'JOB_GET_FAILURE',

    GET_REFERRAL_REQUEST: 'REFERRAL_GET_REQUEST',
    GET_REFERRAL_SUCCESS: 'REFERRAL_GET_SUCCESS',
    GET_REFERRAL_FAILURE: 'REFERRAL_GET_FAILURE',

    GETCLUSTERLIST_REQUEST: 'CLUSTER_GET_REQUEST',
    GETCLUSTERLIST_SUCCESS: 'CLUSTER_GET_SUCCESS',
    GETCLUSTERLIST_FAILURE: 'CLUSTER_GET_FAILURE',

    GETINTERVIEW_REQUEST:'INTERVIEW_GET_REQUEST',
    GETINTERVIEW_SUCCESS:'INTERVIEW_GET_SUCCESS',
    GETINTERVIEW_FAILURE:'INTERVIEW_GET_FAILURE',

    GETSEARCHUSER_REQUEST:'SEARCHUSER_GET_REQUEST',
    GETSEARCHUSER_SUCCESS:'SEARCHUSER_GET_SUCCESS',
    GETSEARCHUSER_FAILURE:'SEARCHUSER_GET_FAILURE',

    GETCITIES_REQUEST:'CITIES_GET_REQUEST',
    GETCITIES_SUCCESS:'CITIES_GET_SUCCESS',
    GETCITIES_FAILURE:'CITIES_GET_FAILURE',

};